<div class="df-dynamic-checkbox-wrapper">
  <mat-checkbox [formControl]="control" [name]="name" [required]="required">
    {{ label }}
  </mat-checkbox>
  <span class="mat-hint df-dynamic-element-hint">{{ hint }}</span>
</div>
